import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

export default function Footer({ contact }) {
  const dial = contact?.phone_dial || "+4962515504920";
  return (
    <footer className="bg-[var(--mf-ink)] text-white/80">
      <div className="mf-container py-16 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/mfmed-logo-light.png" alt="MF MED GmbH Logo" className="h-12 w-auto" />
          <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-xs">
            Medizintechnik, EDV und Dienstleistung. … für Sie unterwegs …
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 font-head font-semibold">Kontakt</div>
          <div className="mt-4 space-y-2 text-sm">
            <div>{contact?.address_line1}</div>
            <div>{contact?.address_line2}</div>
            <div>{contact?.address_line3}</div>
            <a href={`tel:${dial}`} className="flex items-center gap-2 pt-2 hover:text-white"><Phone size={15} /> {contact?.phone}</a>
            <a href={`mailto:${contact?.email}`} className="flex items-center gap-2 hover:text-white"><Mail size={15} /> {contact?.email}</a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 font-head font-semibold">Rechtliches</div>
          <div className="mt-4 space-y-2 text-sm">
            <Link to="/impressum" data-testid="footer-impressum" className="block hover:text-white">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="block hover:text-white">Datenschutz</Link>
            <Link to="/agb" data-testid="footer-agb" className="block hover:text-white">AGB / Widerruf</Link>
            <button
              type="button"
              data-testid="footer-cookie-settings"
              onClick={() => window.dispatchEvent(new Event("mfmed:open-cookie"))}
              className="block text-left hover:text-white"
            >
              Cookie-Einstellungen ändern
            </button>
            <a href="/admin" target="_blank" rel="noopener noreferrer" data-testid="footer-admin" aria-label="Verwaltung (neuer Tab)" title="Verwaltung" className="group inline-block py-2">
              <span className="block w-7 h-0.5 bg-white/[0.12] group-hover:bg-white/40 transition-colors duration-300" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mf-container py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} MF MED GmbH. Alle Rechte vorbehalten.</span>
          <span>Bildnachweis: mf-med.de</span>
        </div>
      </div>
    </footer>
  );
}
